module.exports = __webpack_public_path__ + "src/assets/img/illustrations/defrag.39108c67c0c070d24014169cdd7f9fc7.gif";